import { Link } from "@tanstack/react-router";

import { BuildingIcon, WavesIcon } from "./building-icon";

interface SeeAllLocationsCard {
  location: {
    company: {
      slug: string;
    };
  };
}

export default function SeeAllLocationsCard({ location }: SeeAllLocationsCard) {
  return (
    <Link
      className="relative mr-2 flex h-25 min-w-37.5 flex-col items-center gap-2 rounded-[10px] bg-radial-[50%_50%_at_50%_50%] from-bahama-blue to-sapphire py-2.5 md:mr-0 md:h-auto md:w-full md:min-w-auto"
      to={`/company/${location.company.slug}`}
    >
      <WavesIcon className="absolute inset-0 h-auto w-auto" />
      <BuildingIcon className="relative" />
      <span className="relative font-medium">See all locations</span>
    </Link>
  );
}
